import { module } from 'modujs';

const CLASS = {
    IS_DISABLED: 'is-disabled'
}

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            change: {
                filter: 'onChange'
            }
        }
    }

    init() {
        
        this.$filters = this.$('filter');
        this.values = [true,true];
    }

    onChange(e) {        
        if(!e.currentTarget.checked) {
            this.$filters.forEach((filter, index) => {
                if(e.currentTarget.getAttribute('id') != filter.getAttribute('id')) {
                    if(!filter.checked) filter.checked = true;
                }
            });
        }

        this.$filters.forEach((filter, index) => {
            this.values[index] = filter.checked;
        });
        
        let filterName = 'all';
        console.log(this.values);
        if(this.values[0] && this.values[1]) {
            this.call('filtering',filterName,'Projects');
        } else {
            this.values.forEach((value,index) => {
                if(value) {
                    filterName = this.$filters[index].getAttribute('id').replace('filter-','');
                }
            });
        }

        this.call('filtering',filterName,'Projects');
    }
}
